import { useState, useLayoutEffect } from "react";
function getScrollBehaviours() {
  const { scrollY, scrollX } = window;
  return {
    scrollY,
    scrollX,
  };
}

export default function useScrollBehaviours() {
  const [scrollBehaviours, setScrollBehaviours] = useState(
    getScrollBehaviours()
  );

  useLayoutEffect(() => {
    function trackScrolling() {
      setScrollBehaviours(getScrollBehaviours());
    }

    window.addEventListener("scroll", trackScrolling);
    return () => window.removeEventListener("scroll", trackScrolling);
  }, []);

  return scrollBehaviours;
}
